/**
 * Defers below-fold section init until near viewport.
 * Sets data-defer-ready and dispatches azuli:defer-ready on the observed element.
 */
(function () {
  const ROOT_MARGIN = '320px 0px';
  const SELECTOR = '[data-defer-init]';
  const DESKTOP_MQ = '(min-width: 750px)';

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  const judgeMeHydratePending = new WeakSet();

  function loadJudgeMeWidgets(container) {
    if (window.jdgm && typeof window.jdgm.loadWidgets === 'function') {
      window.jdgm.loadWidgets();
      return true;
    }
    return false;
  }

  function hydrateAppEmbeds(container) {
    if (!container) return;

    const hasJudgeMe = container.querySelector(
      '[id*="judge"], [class*="jdgm"], [data-jdgm], .jdgm-widget, .jdgm-rev-widg'
    );

    if (!hasJudgeMe) return;
    if (loadJudgeMeWidgets(container)) return;
    if (judgeMeHydratePending.has(container)) return;

    judgeMeHydratePending.add(container);

    let attempts = 0;
    const maxAttempts = 50;

    const poll = () => {
      if (loadJudgeMeWidgets(container)) return;
      attempts += 1;
      if (attempts < maxAttempts) {
        setTimeout(poll, 100);
      }
    };

    poll();
  }

  function loadDeferredScript(container) {
    const scriptsAttr = container?.dataset?.deferLoadScripts || container?.dataset?.deferLoadScript;
    if (!scriptsAttr) return;

    const scriptUrls = scriptsAttr
      .split(',')
      .map((url) => url.trim())
      .filter(Boolean);

    scriptUrls.forEach((scriptUrl) => {
      const existing = document.querySelector(`script[src="${scriptUrl}"]`);
      if (existing) return;

      const script = document.createElement('script');
      script.type = 'module';
      script.src = scriptUrl;
      document.head.appendChild(script);
    });
  }

  function markReady(element) {
    if (!element || element.dataset.deferReady === 'true') return;

    element.dataset.deferReady = 'true';
    loadDeferredScript(element);
    hydrateAppEmbeds(element);
    element.dispatchEvent(
      new CustomEvent('azuli:defer-ready', { bubbles: true, detail: { target: element } })
    );
  }

  function init() {
    const elements = document.querySelectorAll(SELECTOR);
    if (!elements.length) return;

    if (isDesktop() || !('IntersectionObserver' in window)) {
      elements.forEach(markReady);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            markReady(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: ROOT_MARGIN, threshold: 0 }
    );

    elements.forEach((element) => {
      const rect = element.getBoundingClientRect();
      const inView = rect.top < window.innerHeight + 320 && rect.bottom > -320;
      if (inView) {
        markReady(element);
      } else {
        observer.observe(element);
      }
    });
  }

  document.addEventListener('shopify:section:load', () => {
    requestAnimationFrame(init);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
